import { IReinsurer } from '../types/reinsurer.type';
import $http from '../services/AxiosInstance';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class ReinsurersRepository {
  static async getReinsurers(allReinsurers: boolean = false) {
    try {
      const response = await $http.get('/reinsurers', {params: allReinsurers ? {flag: 'all'} : {}});
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async getReinsurersProPaginated(params: Params = {}) {
    try {
      let url = `/reinsurers/pro`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async createReinsurer(data: IReinsurer): Promise<IReinsurer> {
    try {
      const { data: { data: reasegurador } } = await $http.post('/reinsurers', data);
      return reasegurador;
    } catch (error) {
      throw Error;
    }
  }

  static async updateReinsurer(data: IReinsurer): Promise<IReinsurer> {
    try {
      const response = await $http.patch(`/reinsurers/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async deleteReinsurer(id: number): Promise<void> {
    try {
      const response = await $http.delete(`/reinsurers/${id}`);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async restoreReinsurer(id: number): Promise<IReinsurer> {
    try {
      const response = await $http.patch(`/reinsurers/${id}/restore`, {});
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async getReinsurersById(id: number): Promise<IReinsurer> {
    try {
      const response = await $http.get(`/reinsurers/${id}`);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
}

export default ReinsurersRepository;
